import React from 'react';
import { BRAND_LOGOS } from '../mock';

const BrandsMarquee = () => {
  const doubled = [...BRAND_LOGOS, ...BRAND_LOGOS];
  return (
    <section className="py-14 border-y border-slate-100 bg-slate-50/40">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <p className="text-center text-sm font-semibold text-slate-500 uppercase tracking-widest mb-8">
          Trusted by 35,000+ Instagrammers, agencies & businesses
        </p>
        <div className="overflow-hidden">
          <div className="marquee">
            {doubled.map((brand, i) => (
              <div key={i} className="shrink-0 text-2xl font-extrabold text-slate-400 tracking-tight px-4">
                {brand}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsMarquee;
